import React, { useRef } from 'react'
import ClickableImageCard from '../custom-components/ClickableImageCard';
import './shineon.css'

function ShineOn() {
    const carouselRef = useRef(null);
        
    const scroll = (direction) => {
        const scrollAmount = 300;
        carouselRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
        });
    };

    const deals = [
        {id: 1, so: "one", image: "https://assets.tatacliq.com/medias/sys_master/images/63588847419422.png"},
        {id: 2, so: "two", image: "https://assets.tatacliq.com/medias/sys_master/images/63588847484958.png"},
        {id: 3, so: "three", image: "https://assets.tatacliq.com/medias/sys_master/images/63588847550494.png"},
        {id: 4, so: "four", image: "https://assets.tatacliq.com/medias/sys_master/images/63588847616030.png"},
        {id: 5, so: "five", image: "https://assets.tatacliq.com/medias/sys_master/images/63588847681566.png"},
        {id: 6, so: "six", image: "https://assets.tatacliq.com/medias/sys_master/images/63588847747102.png"},
    ];


    return (
        <div className="carousel-container">
          <div className="carousel-controls justify-content-end mb-5">
              <button onClick={() => scroll('left')} className="control-button">
                &lt;
              </button>
              <button onClick={() => scroll('right')} className="control-button">
                &gt;
              </button>
            </div>
          
          <div className="image-carousel" ref={carouselRef}>
            {deals.map((deal) => (
              <ClickableImageCard key={deal.id} item={deal} />
            ))}
          </div>
        </div>
      );
}

export default ShineOn